var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.0415C14.9474 1.0415 18.9588 5.05211 18.959 9.99951C18.959 14.9471 14.9476 18.9585 10 18.9585C5.0526 18.9583 1.04199 14.947 1.04199 9.99951C1.04217 5.05222 5.05271 1.04168 10 1.0415ZM13.0898 6.91064C12.7644 6.5852 12.2366 6.58522 11.9111 6.91064L10 8.82178L8.08984 6.91064C7.76446 6.58528 7.23657 6.58538 6.91113 6.91064C6.58571 7.23609 6.58571 7.76393 6.91113 8.08936L8.82129 9.99951L6.91113 11.9106C6.58592 12.236 6.58591 12.763 6.91113 13.0884C7.23656 13.4138 7.7644 13.4138 8.08984 13.0884L10 11.1782L11.9111 13.0894C12.2366 13.4146 12.7645 13.4147 13.0898 13.0894C13.4152 12.764 13.4151 12.2361 13.0898 11.9106L11.1787 9.99951L13.0898 8.08936C13.4152 7.76398 13.4151 7.2361 13.0898 6.91064Z",
    fill: "#C64A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircle);
export default __webpack_public_path__ + "static/media/remove-circle.9b5387792d04b584e371aa92501ce633.svg";
export { ForwardRef as ReactComponent };